export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-background-200 pt-14 md:pt-20 pb-8">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-2 md:col-span-1">
            <span className="font-kuaile text-2xl text-primary-400 mb-3 block">新新漫画</span>
            <p className="text-[13px] leading-relaxed text-background-400">
              韩漫日漫国漫大全，热门漫画类型分类推荐。
              好看漫画一次收藏，找到你想看的漫画类型从这里开始。
            </p>
          </div>

          <div>
            <h4 className="text-[13px] font-bold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {[
                { label: '平台特色', href: '#features' },
                { label: '新新热门榜', href: '#ranking' },
                { label: '漫友社区', href: '#media' },
                { label: '编辑精选', href: '#carousel' },
                { label: '移动阅读', href: '#app' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavClick(link.href);
                    }}
                    className="text-[13px] text-background-400 hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[13px] font-bold text-background-50 mb-4">分类入口</h4>
            <ul className="space-y-2.5">
              {['纯爱', '奇幻', '热血', '悬疑', '搞笑', '都市', '古风', '玄幻'].map((cat) => (
                <li key={cat}>
                  <a
                    href="#topics"
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavClick('#topics');
                    }}
                    className="text-[13px] text-background-400 hover:text-primary-400 transition-colors"
                  >
                    {cat}分类
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[13px] font-bold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-[13px] text-background-500 leading-relaxed">
              感谢所有合作伙伴对新新漫画的支持。合作联系：contact@xinxinmanga.com
            </p>
          </div>
        </div>

        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[12px] text-background-500">
            &copy; 2026 新新漫画 · 韩漫日漫国漫大全。本站内容仅供阅读交流，版权归原作者所有。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }} className="text-[12px] text-background-500 hover:text-primary-400 transition-colors">回到顶部</a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); handleNavClick('#contact'); }} className="text-[12px] text-background-500 hover:text-primary-400 transition-colors">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}